import 'core-js/features/array/from'
import 'core-js/features/object/assign'
import 'intersection-observer'
import smoothscroll from 'smoothscroll-polyfill'
smoothscroll.polyfill()
